import React, { Component } from "react";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "../button";
import Image from "../image";

class Item extends Component {
    _renderImage() {
        const { title, bannerUrl, url, active } = this.props;

        if (!bannerUrl || !active) return null;

        let isVideo = bannerUrl.includes(".mp4");

        return (
            <div className="absolute top-0 right-0 left-0 bottom-0 z-10">
                {url && (
                    <a
                        title={title}
                        className={`w-full h-full overflow-hidden`}
                        href={url}
                    >
                        <Image alt={title} url={bannerUrl} aspectRatio={null} />
                    </a>
                )}
                {!url && !isVideo && (
                    <Image
                        alt={title}
                        className={`w-full h-full overflow-hidden`}
                        url={bannerUrl}
                        aspectRatio={null}
                    />
                )}
                {!url && isVideo && (
                    <div className="video-fullscreen">
                        <ReactPlayer
                            url={bannerUrl}
                            width="100%"
                            height="100%"
                            playing
                            muted
                            playsinline
                        />
                    </div>
                )}
            </div>
        );
    }

    _renderOverlay = () => {
        return (
            <div
                className={`pointer-events-none absolute inset-0 z-10 carousel-gradient`}
            />
        );
    };

    render() {
        const { title, subtitle, buttonVisible, buttonName, onClick, active } =
            this.props;

        return (
            <div
                className={`transition flex absolute w-full h-full flex-col items-start px-16 xl:px-50 pb-80 xl:pb-100 justify-end text-white ${
                    active ? "opacity-100" : "opacity-0"
                }`}
            >
                {this._renderImage()}
                {this._renderOverlay()}
                {title && (
                    <h1
                        className={`font-judge font-bold text-left text-46 xl:text-60 z-10 pointer-events-none xl:max-w-3xl`}
                    >
                        {title.toUpperCase()}
                    </h1>
                )}
                {subtitle && (
                    <h2
                        className={`font-bold text-left text-17 xl:text-34 z-10 pointer-events-none xl:max-w-3xl`}
                    >
                        {subtitle}
                    </h2>
                )}
                {buttonVisible && (
                    <Button
                        text={buttonName}
                        backgroundColor=""
                        backgroundColorOver=""
                        borderColor=""
                        textStyle={`font-judge text-26 z-10 text-opacity-40 transition`}
                        onClick={onClick}
                        style={"w-310 mt-16 z-10"}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
